define.alias("shared/utils/uuid", "settings/utils/uuid");